<template>
<div>
    <div>
         <div id="encabezados-tp">
            <h1>Consulta Audiencias</h1>
            <h3></h3>
            <!-- <div class="hr-titulo"></div> -->
        </div>
           <div class="filtros-busqueda">
               <select name="partido" id="Partido" class='form-control campos' v-model="PartidoJudicial" required>
                 <option value="0" selected>Todos</option>
                 <option v-for="(partido,index) in CATALOGOS.partidoJudicial" :key="index" :value="partido.llave">{{partido.valor}}</option>              
             </select>

             <input type="date" class='form-control campos' v-model="Fecha"/>
             <!-- </div> -->
             <button type="button" class="btn btn-info" @click="ObtenerAudienciasPorGrupo">Ir a Fecha</button>
           </div>
           <div class="reloj">
               {{hora}}
           </div>
        </div>

        <br><br>
    <div>
           <h6></h6>
           <table 
                class="table table-striped table-light table-hover letra-grande"
                id='tabla-audiencas'             
                data-toggle="table"
                data-undefined-text="-"  
                data-click-to-select="false"
                
           >
           <thead  class="thead-dark">
               <tr>
                   <!-- <th data-halign="center" data-width="6" data-align="center"  data-field="audiencia_id">FOLIO</th> -->
                   <th data-halign="center" data-align="center"  data-field="NombrePartido">MUNICIPIO</th>
                <th data-halign="center"  data-align="center"  data-field="ConDetenido">DETENIDO</th>
                    <th data-halign="center" data-align="center"  data-field="carpeta_alias">CARPETA</th>
                   <th data-halign="center" data-align="center"  data-field="FechaDeAudiencia">FECHA DE AUDIENCIA</th>
                   <th data-halign="center" data-align="center"  data-field="HoraDeAudiencia">HORA</th>
                   <th data-halign="center" data-align="center"  data-field="Sala">SALA</th>
                   <th data-halign="center" data-align="center"  data-field="zoom_id">ID ZOOM</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_tipo">AUDIENCIA</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_auxiliar">AUXILIAR</th>
                   <th data-halign="center" data-align="center"  data-field="audiencia_1_juez">JUEZ</th>
                    <th data-halign="center" data-align="center"  data-field="audiencia_status">ESTADO</th>
               </tr>
           </thead>

           </table>
       </div>

</div>
</template>


<script>
import axios from 'axios';
import api from '@/../static/js/api'
import {CATALOGOS} from '../Catalogos/CatalogosBD.js'
import moment from 'moment'

export default{
    data(){
            return{
                CATALOGOS,
                Fecha:moment().format('YYYY-MM-DD'),
                PartidoJudicial:0,
                hora:null,

            }
        },
    methods:{
        ObtenerAudiencias: async function(){
           
            let parametros = {
                Fecha:  this.Fecha,
                PartidoJudicial:this.PartidoJudicial
            }
            const RESPUESTA = await axios.post(api.conexion+'Audiencias/AgendaControlAux/AgendaControlAuxInformatica',parametros,null);
         

            //return await RESPUESTA;
              return await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias);
          //  $("#tabla-audiencas").bootstrapTable({data:await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias)});
          //  $("#tabla-audiencas").bootstrapTable("load",await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias));
        },
obtenerListaAudiencias:async function (){
    await setTimeout(7000);
},

        ObtenerAudienciasPorGrupo:async function(){
         
            let Respuesta = await this.ObtenerAudiencias();
            let Audiencias =Respuesta.filter(a=>a.audiencia_status!="Concluida" && a.audiencia_show==1);
          
            let NumeroCiclos = Audiencias.length/10;
            let CicloInicial = 0;
            let KeyInicio=-1;
            let KeyFinal=10;
       

            setInterval(async () => {
               
                 if(CicloInicial < NumeroCiclos){
                      $("#tabla-audiencas").bootstrapTable('removeAll')
                   let result = Audiencias.filter(function (element,index){
                      if(index>KeyInicio && index<KeyFinal){                       
                          return true
                          }
                       });
                    $("#tabla-audiencas").bootstrapTable({data:result});
                    $("#tabla-audiencas").bootstrapTable("load",result);
                  KeyInicio=KeyInicio+10;
                  KeyFinal=KeyFinal+10;
                  CicloInicial++;
                 }
                 else if(CicloInicial > NumeroCiclos){
                    
                     Respuesta = await this.ObtenerAudiencias();
                     Audiencias =Respuesta.filter(a=>a.audiencia_status!="Concluida" && a.audiencia_show==1);    
                     NumeroCiclos = Audiencias.length/10;
                     CicloInicial = 0;
                     KeyInicio=-1;
                     KeyFinal=10;
                 }
             }, (1000 * 10) );

            
        },
        formatoAudienciasJuez:async function(doc){
            let documento
            documento = doc.map(c => {
                let docFormateado = c;
                var NombrePartido =CATALOGOS.partidoJudicial.filter(a=>a.llave==c.partido_id);
                docFormateado.Sala = (c.audiencia_sala!=null)?c.audiencia_sala+" "+c.audiencia_modo : "-";
                docFormateado.FechaDeAudiencia = (c.audiencia_fecha!=null)?c.audiencia_fecha.split('T')[0]:"-";
                docFormateado.HoraDeAudiencia = (c.audiencia_fecha!=null)?c.audiencia_fecha.split('T')[1]:"-";
                docFormateado.NombrePartido = NombrePartido[0].valor;
                docFormateado.FechaAgendada = (c.audiencia_registrada!=null)?c.audiencia_registrada.split('T')[0]:"-";
                docFormateado.ConDetenido = (c.audiencia_detenido == 1)?"Si":"No";
                return docFormateado;
            });
            return documento;
        },
     

Reloj:function () {
    var today = new Date();
    var hr = today.getHours();
    var min = today.getMinutes();
    var sec = today.getSeconds();
    min = this.checkTime(min);
    sec = this.checkTime(sec);
    this.hora =  hr + " : " + min + " : " + sec;
},
checkTime:function(i)  {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
},       
    },
    mounted(){
       setInterval(()=>{ this.Reloj() }, 1000);
    },
}


</script>
<style scoped>
.letra-grande{
    font-size: 1.2em;
    font-weight: bold;
    font-family:'Open Sans', sans-serif;
}
.reloj{
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    margin-right: .5em;
    font-weight: bold;
    font-size: 6em;

}
.campos{
    width: 20%;
}
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/Audiencias/VistaMonitor/VistaMonitor.vue